import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { ISmevResendResponse } from '../interfaces/ISmevResendResponse';

export async function fetchSmevResendBySendingDateList(
  startDate: string,
  endDate: string,
  page: number,
): Promise<ISmevResendResponse> {
  return fetch(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/smev-resend/get-by-sending-date?startDate=${startDate}&endDate=${endDate}&page=${page}&size=50`,
    {
      method: 'GET',
      credentials: 'include',
    },
  ).then(handleResponse);
}
